import styled, { css } from 'styled-components'
import { titleFont } from 'shared/css/fonts.css'

export default styled.h1`
    clear: both;
    color: ${(props) => props.theme.primaryColor};
    font-family: ${titleFont};
    font-size: 36px;
    line-height: 1.2;
    margin-bottom: 8px;
    text-align: left;

    ${(props) =>
        props.theme.secondaryColor &&
        css`
            background: linear-gradient(
                to right,
                ${(props) => props.theme.primaryColor} 0%,
                ${(props) => props.theme.secondaryColor} 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        `};
`
